import {atom, DefaultValue, selector} from "recoil";
import {HttpResponseType, IRFMContractorData} from "./model";

/************** ATOM & SELECTOR ***************/

export const RFMState = atom({
    key: 'RFMState',
    default: {
        isSubmit:{
            value: false
        },
        newRegistration: {
            value: {  }
        },
        buttonConfirmed: {
            value: {  }
        },
        validatedForm: {
            value: false
        },
        submitConfirmed: {
            value: false
        },
        formEditing: {
            value: 0
        },
        idEntity: {
            value: 0
        },
        terminated: {
            value: false
        },
        openDialog: {
            value: false
        },
        contractorData: {
            value: {
                id: 0,
                documents: [],
                bpCode: "",
                icaoCode: "",
                iataCode: "",
                companyName: "",
                type: "",
                notes: "",
                currentStatus: "",
                royaltiesDued: 'NO',
                vatNumber: "",
                fiscalCode: "",
                legalAddress: "",
                legalStreetNumber: "",
                postalCode: "",
                area: "",
                areaManager: "",
                country:"",
                region: "",
                province: "",
                city: "",
                fax: "",
                pec: "",
                commercialExecutiveName: "",
                naming: "",
                acgIdentificationCode: "",
                serviceType: "",
                royaltiesPercentage: "",
                bpCodeOfTheRepresentative: "",
                taxCode: "",
                representativeIdentificationCode: "",
                commercialExecutiveMail: "",
                prefixCommercialExecutiveDeskPhone: {
                    code: "",
                    description: "",
                    label: ""
                },
                commercialExecutiveDeskPhone: "",
                prefixCommercialExecutiveCellPhone: {
                    code: "",
                    description: "",
                    label: ""
                },
                commercialExecutiveCellPhone: "",
                nameOfTheContactPerson: "",
                emailOfTheContactPerson: "",
                cellPhoneNumberOfTheContactPerson: "",
                prefixCellPhoneNumberOfTheContactPerson: {
                    code: "",
                    description: "",
                    label: ""
                },
                iban: "",
                emailRoyalties: "",
                associatedDms: [],
            },
        },
        RFMFilterParams: {}
    }
});

// Generic response
export const rmfFilterParams = selector<any>({
    key: 'RFMFilterParams',
    get: ({ get }) => get(RFMState).RFMFilterParams,
    set: ({ set, get }, newValue) => {
        set(RFMState, {
            ...get(RFMState),
            RFMFilterParams: newValue instanceof DefaultValue ? get(RFMState).RFMFilterParams : newValue
        })
    }
});

export const responseState = atom<HttpResponseType<any>>({
    key: 'responseState',
    default: {
        data: { value: {}},
        loading: false,
        error: ''
    }
});

export const RFMDataSearch = atom<IRFMContractorData[]>({
    key: 'RFMDataSearch',
    default: []
});

export const contractorRoyaltiesState = atom<any>({
    key: 'contractorRoyaltiesState',
    default: {
        contractor: {},
        royaltiesFilterParams: {},
    }
});

export const isSubmitState = selector<any>({
    key: 'isSubmitState',
    get: ({get}) => get(RFMState).isSubmit.value,
    set: ({get, set}, newValue) => {
        set(RFMState, {
            ...get(RFMState),
            isSubmit: {
                ...get(RFMState).isSubmit,
                value: newValue instanceof DefaultValue ? get(RFMState).isSubmit.value : newValue
            }
        })
    }
});

export const openDialogState = selector<any>({
    key: 'openDialogState',
    get: ({get}) => get(RFMState).openDialog.value,
    set: ({get, set}, newValue) => {
        set(RFMState, {
            ...get(RFMState),
            openDialog: {
                ...get(RFMState).openDialog,
                value: newValue instanceof DefaultValue ? get(RFMState).openDialog.value : newValue
            }
        })
    }
});

export const newRegistrationState = selector<any>({
    key: 'newRegistrationState',
    get: ({get}) => get(RFMState).newRegistration.value,
    set: ({get, set}, newValue) => {
        set(RFMState, {
            ...get(RFMState),
            newRegistration: {
                ...get(RFMState).newRegistration,
                value: newValue instanceof DefaultValue ? get(RFMState).newRegistration.value : newValue
            }
        })
    }
});

export const idEntityState = selector<any>({
    key: 'idEntityState',
    get: ({get}) => get(RFMState).idEntity.value, // TODO: l'id dell'entità appena creata/selezionata recuperata dal database e attraverso il path_suffix nella URL Browser
    set: ({get, set}, newValue) => {
        set(RFMState, {
            ...get(RFMState),
            idEntity: {
                ...get(RFMState).idEntity,
                value: newValue instanceof DefaultValue ? get(RFMState).idEntity.value : newValue
            }
        })
    }
});

export const buttonConfirmedState = selector<any>({
    key: 'buttonConfirmedState',
    get: ({get}) => get(RFMState).buttonConfirmed.value,
    set: ({get, set}, newValue) => {
        set(RFMState, {
            ...get(RFMState),
            buttonConfirmed: {
                ...get(RFMState).buttonConfirmed,
                value: newValue instanceof DefaultValue ? get(RFMState).buttonConfirmed.value : newValue
            }
        })
    }
});

export const validatedFormState = selector<any>({
    key: 'validatedFormState',
    get: ({get}) => get(RFMState).validatedForm.value,
    set: ({get, set}, newValue) => {
        set(RFMState, {
            ...get(RFMState),
            validatedForm: {
                ...get(RFMState).validatedForm,
                value: newValue instanceof DefaultValue ? get(RFMState).validatedForm.value : newValue
            }
        })
    }
});

export const formEditingState = selector<any>({
    key: 'formEditingState',
    get: ({get}) => get(RFMState).formEditing.value,
    set: ({get, set}, newValue) => {
        set(RFMState, {
            ...get(RFMState),
            formEditing: {
                ...get(RFMState).formEditing,
                value: newValue instanceof DefaultValue ? get(RFMState).formEditing.value : newValue
            }
        })
    }
});

export const completedSubmitState = selector<any>({
    key: 'completedSubmitState',
    get: ({get}) => get(RFMState).submitConfirmed.value,
    set: ({get, set}, newValue) => {
        set(RFMState, {
            ...get(RFMState),
            submitConfirmed: {
                ...get(RFMState).submitConfirmed,
                value: newValue instanceof DefaultValue ? get(RFMState).submitConfirmed.value : newValue
            }
        })
    }
});

export const RFMContractorDataValueState = selector<any>({
    key: 'RFMContractorDataValueState',
    get: ({get}) => get(RFMState).contractorData.value,
    //     async ({get}) => {
    //     const response = await restContractorService(get(RFMState).contractorData.value, 'upload', DMS_ENTITY.data.id)
    // },
    set: ({get, set}, newValue) => {
        set(RFMState, {
            ...get(RFMState),
            contractorData: {
                ...get(RFMState).contractorData,
                value: newValue instanceof DefaultValue ? get(RFMState).contractorData.value : newValue
            }
        });
        // console.log(JSON.stringify(newValue))
    }
});

export const RFMContractorAssociationDataValueState = selector<any>({
    key: 'RFMContractorAssociationDataValueState',
    get: ({get}) => get(RFMState).contractorData.value.associatedDms,
    //     async ({get}) => {
    //     const response = await restContractorService(get(RFMState).contractorData.value, 'upload', DMS_ENTITY.data.id)
    // },
    set: ({get, set}, newValue) => {
        set(RFMState, {
            ...get(RFMState),
            contractorData: {
                ...get(RFMState).contractorData,
                value: {
                    ...get(RFMState).contractorData.value,
                    associatedDms: newValue instanceof DefaultValue ? get(RFMState).contractorData.value.associatedDms : newValue
                }
            }
        });
        // console.log(JSON.stringify(newValue))
    }
});

export const RFMContractorDocuments = selector<any>({
    key: 'RFMContractorDocuments',
    get: ({get}) => get(RFMState).contractorData.value.documents,
    //     async ({get}) => {
    //     const response = await restContractorService(get(RFMState).contractorData.value, 'upload', DMS_ENTITY.data.id)
    // },
    set: ({get, set}, newValue) => {
        set(RFMState, {
            ...get(RFMState),
            contractorData: {
                ...get(RFMState).contractorData.value.documents,
                value: newValue instanceof DefaultValue ? get(RFMState).contractorData.value.documents : newValue
            }
        });
        // console.log(JSON.stringify(newValue))
    }
});

// export const checkRFMValidityValueState = selector<any>({
//     key: 'checkRFMContractorValidity',
//     get: ({get}) => get(RFMState).checkRFMContractorValidity.value,
//     set: ({get, set}, newValue) => {
//         set(RFMState, {
//             ...get(RFMState),
//             checkRFMContractorValidity: {
//                 ...get(RFMState).checkRFMContractorValidity,
//                 value: newValue instanceof DefaultValue ? get(RFMState).checkRFMContractorValidity.value : newValue
//             }
//         })
//     }
// });

export const entityTerminatedState = selector<any>({
    key: 'entityTerminatedState',
    get: ({get}) => get(RFMState).terminated.value,
    set: ({get, set}, newValue) => {
        set(RFMState, {
            ...get(RFMState),
            terminated: {
                ...get(RFMState).terminated,
                value: newValue instanceof DefaultValue ? get(RFMState).terminated.value : newValue
            }
        })
    }
});

export const getsetResponseState = selector<any>({
    key: 'getsetMockResponseState',
    get: ({get}) => get(responseState).data.value,
    set: ({get, set}, newValue) => {
        set(responseState, {
            ...get(responseState),
            data: {
                ...get(responseState).data,
                value: newValue instanceof DefaultValue ? get(responseState).data.value : newValue
            }
        })
    }
});

export const royaltiesFilterParams = selector<any>({
    key: 'royaltiesFilterParams',
    get: ({ get }) => get(contractorRoyaltiesState).royaltiesFilterParams,
    set: ({ set, get }, newValue) => {
        set(contractorRoyaltiesState, {
            ...get(contractorRoyaltiesState),
            royaltiesFilterParams: newValue instanceof DefaultValue ? get(contractorRoyaltiesState).royaltiesFilterParams : newValue
        })
    }
});
